const _import = require('@/router/_import_' + process.env.NODE_ENV);
import Vue from 'vue'
import Router from 'vue-router'
// import mainPage from '@/components/mainPage/mainPage'
import aboutPage from '@/components/aboutPage/aboutPage'
import contactPage from '@/components/contactPage/contactPage'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject)
    }
    return originalPush.call(this, location).catch(err => err)
}

import homePage from '../views/home/homePage/homePage.vue'
import Login from '../views/home/login/Login.vue'
import Tokenlogin from '../views/home/tokenlogin/Tokenlogin.vue'
import Register from '../views/home/register/Register.vue'
import ChangePass from '../views/share/UserManage/ChangePass.vue'
import AliPay from '../views/share/AliPay/AliPay.vue'
import Agreement from "../views/public/Agreement/Agreement";
import WiffaLoginPage from "../views/home/wiffaHomePage/wiffaLoginPage.vue";
import jwt_decode from "jwt-decode";
// import AppMain from '@/layout'

export const constantRoutes = []
// const components = {
//   '/Layout' : () => import('@/layout/Layout.vue'),
//   '/Home' : () => import('@/views/business/Home')
// }

const createRouter = (all, current) => {
    // 旧逻辑
    // let routeData = sessionStorage.getItem('currentSystem');
    // if (routeData) {
    //     routeData = JSON.parse(routeData).routeData;
    // }
    // if (!routeData) {
    //     routeData = [];
    // }
    // 新逻辑
    // 获取所有菜单
    let allMenu = all ? all : sessionStorage.getItem('allMenu');
    let currentSystem = current ? current : sessionStorage.getItem('currentSystem');
    if (allMenu) {
        allMenu = JSON.parse(allMenu);
    } else {
        allMenu = [];
    }
    if (currentSystem) {
        currentSystem = JSON.parse(currentSystem);
    } else {
        currentSystem = {};
    }
    let currentCode = Number(currentSystem.code);
    const routeData = [];
    let changedSys = false;
    // 当前系统是4，游客
    if (currentCode === 4) {
        // 如果当前公司是wiffa，则使用客服系统菜单，否则使用自己的
        console.log(sessionStorage.getItem('token'));
        const companyName = jwt_decode(sessionStorage.getItem('token')).customerCompanyCnName;
        if (companyName === 'WIFFA') {
            currentCode = 1;
            changedSys = true;
        }
    }
    allMenu.forEach(item => {
        if (item.forSystem === currentCode) {
            routeData.push(item);
        }
    });

    if (changedSys) {
        routeData.forEach((item, index) => {
            if (item.url === '/home' || item.url === '/base') {
                routeData.splice(index, 1);
            }
        });
        allMenu.forEach(item => {
            if (item.forSystem === 4 && (item.url === '/company' || item.url === '/home')) {
                routeData.unshift(item);
            }
        });
    }

    // const routeData = JSON.parse(sessionStorage.getItem('routeData'))
    constantRoutes.splice(0, constantRoutes.length);
    constantRoutes.push({
        path: '/login',
        component: Login,
        // children: [{
        //   path: 'dashboard',
        //   name: 'Dashboard',
        //   component: () => import('@/views/dashboard/index'),
        //   meta: {
        //     title: '系统主页',
        //     icon: 'dashboard'
        //   }
        // }
        // ]
    }, {
        path: '/tokenlogin',
        component: Tokenlogin
    }, {
        path: '/agreement',
        component: Agreement
    }, {
        path: '/',
        name: 'mainPage',
        component: homePage
    },
        {
            path: '/aboutPage',
            name: 'aboutPage',
            component: aboutPage
        },
        {
            path: '/alipay',
            name: 'alipay',
            component: AliPay
        },
        {
            path: '/contactPage',
            name: 'contactPage',
            component: contactPage
        },
        {
            path: '/wlogin',
            name: 'WiffaLoginPage',
            component: WiffaLoginPage
        });
    constantRoutes.push({
        path: '/Register',
        component: Register,
    });
    const layout = {
        path: '/Layout',
        component: () => import('../layout/Layout.vue'),
        children: [],
    };
    constantRoutes.push(layout);
    if (routeData && routeData.length > 0) {
        addDynamicRoutes(routeData, layout.children, currentSystem.routeData)
    }
    console.log(layout.children);
    layout.children.push({
        path: '/change-pass',
        component: ChangePass,
        name: "修改密码",
        meta: {
            basePath: "/base",
            enTitle: "change password",
            hasPermission: true, 
            id: -1,
            title: "修改密码",
            zhTitle: "修改密码"
        }
    })

    // const vueRouter = new Router({
    //     scrollBehavior: () => ({
    //         y: 0
    //     }),
    //     routes: constantRoutes
    // });
    // // 注册路由守卫
    // vueRouter.beforeEach((to, from, next) => {
    //     if(['/Register','/contactPage','/alipay','/aboutPage','/','/agreement','/change-pass','/login'].indexOf(to.path) !== -1){
    //         next();
    //         return;
    //     }
    //     if(currentSystem.routeData){
    //         let queue = []; // 借助一个队列
    //         queue.push(...currentSystem.routeData);
    //         while (queue.length) {
    //             let curNode = queue.shift(); // 推出队头元素
    //             if(curNode.id === to.meta.id){
    //                 next();
    //                 return;
    //             }
    //             if (curNode.children && curNode.children.length) {
    //                 queue = queue.concat(curNode.children);
    //             }
    //         }
    //         next(false);
    //         let message = 'You do not have access to the current function, please contact the administrator';
    //         if(sessionStorage.getItem('locale').indexOf('zh') !== -1){
    //             message = '您没有当前功能的使用权限，请联系管理员';
    //         }
    //         Vue.prototype.$message({
    //             message: message,
    //             type: 'error',
    //             center: true
    //         });
    //     }
    // });
    //
    // return vueRouter;
    return new Router({
        scrollBehavior: () => ({
            y: 0
        }),
        routes: constantRoutes
    });
};

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter(all, current) {
    const newRouter = createRouter(all, current)
    router.matcher = newRouter.matcher // reset router
    // router = newRouter
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function addDynamicRoutes(menuList = [], layout, hasPermissionData) {
    menuList.forEach(levl1 => {
        let component = () => import('../layout/ParentView.vue');
        let noPermissionComponent = () => import('../layout/NoPermissionComponent.vue');
        if (levl1.file) {
            component = _import(levl1.file)
        }
        let queueP = []; // 借助一个队列
        queueP.push(...hasPermissionData);
        let hasP = false;
        while (queueP.length) {
            let curNode = queueP.shift(); // 推出队头元素
            if (curNode.id === levl1.id) {
                hasP = true;
            }
            if (curNode.children && curNode.children.length) {
                queueP = queueP.concat(curNode.children);
            }
        }
        if (!hasP) {
            component = noPermissionComponent;
        }
        const l1Router = {
            path: levl1.url,
            name: levl1.displayText,
            component: component,
            meta: {
                id: levl1.id,
                icon: levl1.icon,
                zhTitle: levl1.displayText,
                enTitle: levl1.tooltipText,
                basePath: '',
                hasPermission: hasP
            }
        };
        const l1Children = [];
        l1Router.children = l1Children;
        if (levl1.children) {
            levl1.children.forEach(levl2 => {
                let l2Component = _import(levl2.file);
                let queue = []; // 借助一个队列
                queue.push(...hasPermissionData);
                let has = false;
                while (queue.length) {
                    let curNode = queue.shift(); // 推出队头元素
                    if (curNode.id === levl2.id) {
                        has = true;
                    }
                    if (curNode.children && curNode.children.length) {
                        queue = queue.concat(curNode.children);
                    }
                }
                if (!has) {
                    l2Component = noPermissionComponent;
                }
                const l2Router = {
                    path: levl2.url,
                    name: levl2.displayText,
                    component: l2Component,
                    meta: {
                        id: levl2.id,
                        icon: levl2.icon,
                        zhTitle: levl2.displayText,
                        enTitle: levl2.tooltipText,
                        basePath: levl1.url,
                        hasPermission: has
                    }
                };
                l1Children.push(l2Router)
            });
        }
        layout.push(l1Router)
    });
}

export default router
